import React, { useCallback, useMemo, useState } from "react";
import { BackLink, Intro } from "components/commons";
import { locale } from "localization/en";
import { FormMode, Path, ShiftStatus } from "enums";
import PanelButtons from "components/commons/panel-button/panel-buttons";
import ShiftDetailsInfoTab from "./shift-details/info.module";
import WetStockTab from "./wet-stock/wet-stock.module";
import DryStockTab from "./dry-stock/dry-stock.module";
import CashNonCashTab from "./cash-noncash/cash-noncash.module";
import { useApi, useForm, useModal, useMount, useRouter } from "hooks";
import { getShiftByShiftId } from "apis";
import { calculateSyncProgress } from "../shift-records.mapper";
import Big from "big.js";
import { sortBy, sumBy } from "lodash";
import ProductCode from "enums/product-code";
import { validateReadingDipstick } from "./wet-stock/shift-details-stock-inventory-dipstick";
import { initialState as formState } from "./shift-records-details.state";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { SuccessModal } from "components/modals";
import { StocqClockIn } from "images";
const ShiftRecordDetailsModule = () => {
  const { query } = useRouter();
  const successModal = useModal();
  const history = useHistory();
  const shiftId = query?.id;
  const pageMode = query?.mode;

  const [page, setPage] = useState("info");

  const [employees, setEmployees] = useState([]);
  const [employeesToPay, setEmployeesToPay] = useState([]);
  const [variance, setVariance] = useState(0);
  const [beginDidNotPerformDipStick, setBeginDidNotPerformDipStick] = useState(false);
  const [endDidNotPerformDipStick, setEndDidNotPerformDipStick] = useState(false);
  const [safeDropId, setSafeDropId] = useState(null);
  const [safeDrop, setSafeDrop] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [remarksUgt, setRemarksUgt] = useState("");

  useMount(async () => {
    if (shiftId) {
      const res = await getShiftRequest();
      // await fetchValidation();

      // if (res.shift.stationCode !== station.stationCode) {
      //   return routerPush(Path.ShiftRecords);
      // }

      let safeDropItem = {
        oneThousand: 0,
        fiveHundred: 0,
        twoHundred: 0,
        oneHundred: 0,
        fifty: 0,
        twenty: 0,
        twentyCoins: 0,
        ten: 0,
        five: 0,
        coinAmount: 0,
      };

      let safeDropEndShiftItem = {
        oneThousand: 0,
        fiveHundred: 0,
        twoHundred: 0,
        oneHundred: 0,
        fifty: 0,
        twenty: 0,
        twentyCoins: 0,
        ten: 0,
        five: 0,
        coinAmount: 0,
      };

      if (res) {
        if (res?.safeDrop) {
          safeDropItem = res.safeDrop;
        }

        if (res?.safeDropEndShift) {
          safeDropEndShiftItem = res.safeDropEndShift;
          setSafeDropId(safeDropEndShiftItem.safeDropId);
        }
      }

      let safeDropsList = [
        {
          key: "oneThousand",
          denomination: 1000,
          safeDropItem: safeDropItem.oneThousand,
          safeDrop: safeDropEndShiftItem.oneThousand || 0,
          total: Number(Big(safeDropItem.oneThousand).add(safeDropEndShiftItem.oneThousand)),
          totalAmount: Number(
            Big(safeDropItem.oneThousand).add(safeDropEndShiftItem.oneThousand).mul(1000),
          ),
        },
        {
          key: "fiveHundred",
          denomination: 500,
          safeDropItem: safeDropItem.fiveHundred,
          safeDrop: safeDropEndShiftItem.fiveHundred || 0,
          total: Number(Big(safeDropItem.fiveHundred).add(safeDropEndShiftItem.fiveHundred)),
          totalAmount: Number(
            Big(safeDropItem.fiveHundred).add(safeDropEndShiftItem.fiveHundred).mul(500),
          ),
        },
        {
          key: "twoHundred",
          denomination: 200,
          safeDropItem: safeDropItem.twoHundred,
          safeDrop: safeDropEndShiftItem.twoHundred || 0,
          total: Number(Big(safeDropItem.twoHundred).add(safeDropEndShiftItem.twoHundred)),
          totalAmount: Number(
            Big(safeDropItem.twoHundred).add(safeDropEndShiftItem.twoHundred).mul(200),
          ),
        },
        {
          key: "oneHundred",
          denomination: 100,
          safeDropItem: safeDropItem.oneHundred,
          safeDrop: safeDropEndShiftItem.oneHundred || 0,
          total: Number(Big(safeDropItem.oneHundred).add(safeDropEndShiftItem.oneHundred)),
          totalAmount: Number(
            Big(safeDropItem.oneHundred).add(safeDropEndShiftItem.oneHundred).mul(100),
          ),
        },
        {
          key: "fifty",
          denomination: 50,
          safeDropItem: safeDropItem.fifty,
          safeDrop: safeDropEndShiftItem.fifty || 0,
          total: Number(Big(safeDropItem.fifty).add(safeDropEndShiftItem.fifty)),
          totalAmount: Number(Big(safeDropItem.fifty).add(safeDropEndShiftItem.fifty).mul(50)),
        },
        {
          key: "twenty",
          denomination: 20,
          safeDropItem: safeDropItem.twenty,
          safeDrop: safeDropEndShiftItem.twenty || 0,
          total: Number(Big(safeDropItem.twenty).add(safeDropEndShiftItem.twenty)),
          totalAmount: Number(Big(safeDropItem.twenty).add(safeDropEndShiftItem.twenty).mul(20)),
        },
        {
          key: "twentyCoins",
          denomination: 20,
          safeDropItem: safeDropItem.twentyCoins,
          safeDrop: safeDropEndShiftItem.twentyCoins || 0,
          total: Number(Big(safeDropItem.twentyCoins).add(safeDropEndShiftItem.twentyCoins)),
          totalAmount: Number(
            Big(safeDropItem.twentyCoins).add(safeDropEndShiftItem.twentyCoins).mul(20),
          ),
        },
        {
          key: "ten",
          denomination: 10,
          safeDropItem: safeDropItem.ten,
          safeDrop: safeDropEndShiftItem.ten || 0,
          total: Number(Big(safeDropItem.ten).add(safeDropEndShiftItem.ten)),
          totalAmount: Number(Big(safeDropItem.ten).add(safeDropEndShiftItem.ten).mul(10)),
        },
        {
          key: "five",
          denomination: 5,
          safeDropItem: safeDropItem.five,
          safeDrop: safeDropEndShiftItem.five || 0,
          total: Number(Big(safeDropItem.five).add(safeDropEndShiftItem.five)),
          totalAmount: Number(Big(safeDropItem.five).add(safeDropEndShiftItem.five).mul(5)),
        },
        {
          key: "coinAmount",
          denomination: 1,
          safeDropItem: safeDropItem.coinAmount,
          safeDrop: safeDropEndShiftItem.coinAmount || 0,
          total: Number(Big(safeDropItem.coinAmount).add(safeDropEndShiftItem.coinAmount)),
          totalAmount: Number(
            Big(safeDropItem.coinAmount).add(safeDropEndShiftItem.coinAmount).mul(1),
          ),
        },
      ];

      if (res.shift.status === ShiftStatus.Started) {
        safeDropsList = safeDropsList.map((row) => ({
          ...row,
          safeDrop: 0, // End of Shift
          safeDropItem: row.safeDrop + row.safeDropItem,
        }));
      }

      setSafeDrop(safeDropsList);

      //set initial value of variance
      const { expense } = res.shift;
      const totalExpenses = sumBy(expense, "amount") || 0;
      const { beginningCashBalance } = res.shift;
      const cashTransactions = res?.transactionPaymentMethod?.cash || [];
      const netCashSales = cashTransactions.reduce(
        (sum, item) => Number(Big(sum).add(Big(item.totalAmount || 0).minus(item.discount || 0))),
        0,
      );
      const totalSafeDrop = sumBy(safeDrop, "totalAmount") || 0;
      const cashOnHand = Number(Big(beginningCashBalance).add(netCashSales).minus(totalExpenses));
      setVariance(Number(Big(totalSafeDrop).minus(cashOnHand)));
    }
  });

  const {
    request: getShiftRequest,
    loading: loadingShift,
    result: getShiftResult,
  } = useApi({
    api: getShiftByShiftId,
    modalError: true,
    params: {
      shiftId,
    },
  });

  // Refetch function to reload shift data
  const refetchShift = useCallback(async () => {
    await getShiftRequest();
  }, [getShiftRequest]);

  // const fetchValidation = async () => {
  //   try {
  //     await validationRequest();
  //   } catch (err) {
  //     if (err.status === 400) {
  //       setExistingShiftOpen(true);
  //     }
  //   }
  // };

  const setFieldCode = (field) => {
    let productCode;
    if (field.includes("Diesel")) {
      productCode = ProductCode.DIESEL;
    }

    if (field.includes("Gas91")) {
      productCode = ProductCode.GAS91;
    }

    if (field.includes("Gas95")) {
      productCode = ProductCode.GAS95;
    }

    if (field.includes("Gas97")) {
      productCode = ProductCode.GAS97;
    }

    return productCode;
  };

  const items = [
    {
      text: locale.shiftRecords,
      page: "info",
      onClick: () => {
        setPage("info");
      },
    },
    {
      text: locale.wetStockInventory,
      page: "wet-stock-inventory",
      onClick: () => {
        setPage("wet-stock-inventory");
      },
    },
    {
      text: locale.dryStockInventory,
      page: "dry-stock-inventory",
      onClick: () => {
        setPage("dry-stock-inventory");
      },
    },
    {
      text: locale.cashAndNonCash,
      page: "cash-noncash",
      onClick: () => {
        setPage("cash-noncash");
      },
    },
  ];

  const transformData = useMemo(() => {
    const getShiftDetailFields = ["isReadingDipstickBeginning", "isReadingDipstickEnding"];

    const getDipstickFields = [
      "beginningDiesel",
      "beginningGas91",
      "beginningGas95",
      "beginningGas97",
      "beginningDieselCm",
      "beginningGas91Cm",
      "beginningGas95Cm",
      "beginningGas97Cm",
      "endingDiesel",
      "endingGas91",
      "endingGas95",
      "endingGas97",
      "endingDieselCm",
      "endingGas91Cm",
      "endingGas95Cm",
      "endingGas97Cm",
    ];

    let state = {};

    if (getShiftResult) {
      const isReadingDipstickBeginning = getShiftResult?.shift.isReadingDipstickBeginning;
      const isReadingDipstickEnding = getShiftResult?.shift.isReadingDipstickEnding;

      const shiftDetailsResult = getShiftDetailFields.map((field) => ({
        [field]:
          field === "shiftNumber" ? getShiftResult?.shift[field] : !getShiftResult?.shift[field],
      }));

      const stationProducts = getShiftResult?.station?.stationUgt.map((item) => item.productCode);

      shiftDetailsResult.forEach((item) => {
        const key = Object.keys(item)[0];

        state[key] = {
          value: item[key],
          disabled: false,
          required: key === "shiftNumber" && pageMode === FormMode.Edit,
        };
      });

      const dipstickResult = getDipstickFields.map((field) => ({
        [field]: parseFloat(getShiftResult?.shift[field]).toFixed(3),
      }));

      const stationUgts = getShiftResult?.station?.stationUgt;

      const getMaxLiter = (fieldName) => {
        fieldName = fieldName?.toLowerCase();
        if (fieldName.includes("cm")) return undefined;

        const product = stationUgts?.find((ugt) => fieldName?.includes(ugt?.productCode));
        if (!product) return undefined;

        return product?.liter;
      };

      dipstickResult.forEach((item) => {
        const key = Object.keys(item)[0];
        if (
          [
            "beginningDiesel",
            "beginningGas91",
            "beginningGas95",
            "beginningGas97",
            "beginningDieselCm",
            "beginningGas91Cm",
            "beginningGas95Cm",
            "beginningGas97Cm",
          ].includes(key)
        ) {
          state[key] = {
            value: isReadingDipstickBeginning ? item[key] : "",
            disabled: !isReadingDipstickBeginning,
            required: !isReadingDipstickBeginning && stationProducts.includes(setFieldCode(key)),
            dirty: !isReadingDipstickBeginning,
          };
        } else if (
          [
            "endingDiesel",
            "endingGas91",
            "endingGas95",
            "endingGas97",
            "endingDieselCm",
            "endingGas91Cm",
            "endingGas95Cm",
            "endingGas97Cm",
          ].includes(key)
        ) {
          state[key] = {
            value: isReadingDipstickEnding ? item[key] : "",
            disabled: !isReadingDipstickEnding,
            required: !isReadingDipstickEnding && stationProducts.includes(setFieldCode(key)),
            dirty: !isReadingDipstickEnding,
          };
        } else {
          state[key] = {
            value: item[key],
            disabled: false,
            required: stationProducts.includes(setFieldCode(key)),
          };
        }

        state[key] = {
          ...state[key],
          maxLiter: getMaxLiter(key),
        };
      });

      const shiftEmployees = getShiftResult?.shift.employees;

      if (shiftEmployees) {
        const newEmployees = shiftEmployees.map((i) => {
          i.nameCheck = false;
          i.agencyCheck = false;
          i.labelCheck = false;
          return i;
        });

        setEmployees(sortBy(newEmployees, "shiftEmployeeId"));
      }

      const initialInventory = getShiftResult?.shift.inventories.map((item) => ({
        shiftInventoryId: item.shiftInventoryId,
        beginningInventory: item.beginningInventory,
        endingInventory: item.endingInventory,
      }));

      setInventory(initialInventory);

      const requiredFieldsBeginning = validateReadingDipstick(
        "isReadingDipstickBeginning",
        false,
        state,
        false,
        getShiftResult.recentShift,
      );

      const requiredFieldsEnding = validateReadingDipstick(
        "isReadingDipstickEnding",
        false,
        state,
        false,
        getShiftResult.recentShift,
      );
      state = {
        ...state,
        ...requiredFieldsBeginning,
        ...requiredFieldsEnding,
      };
    }
    return state;
  }, [getShiftResult, pageMode]);

  const form = useMemo(() => {
    let initialState = transformData || {};
    return formState(initialState);
  }, [transformData]);

  const formData = useForm({
    initialState: form,
  });

  // const { isFormSubmittable, getFormValues } = formData;

  const shift = getShiftResult?.shift;

  const totalTransactionCount = shift?.totalTransactionCount || 0;
  const totalBosTransactionCount = shift?.totalBosTransactionCount || 0;
  const progress = calculateSyncProgress({
    totalBosTransactionCount: totalBosTransactionCount,
    totalTransactionCount,
  });

  const isShiftEndedCompletely =
    getShiftResult &&
    [ShiftStatus.Ended, ShiftStatus.Closed].includes(getShiftResult?.shift.status) &&
    progress >= 100;

  return (
    <>
      <div>
        <SuccessModal
          image={StocqClockIn}
          title={locale.closeShift}
          content={locale.successMessageModalCloseShift}
          {...successModal}
          close={() => {
            successModal.close();
          }}
          primary={{
            text: locale.gotIt,
            onClick: () => {
              successModal.close();
              history.push(Path.ShiftRecords);
            },
          }}
        />
        <BackLink text={locale.shiftRecords} path={Path.ShiftRecords} />
        <Intro title={locale.shiftReportDetails} />
        <div style={{ marginBottom: "30px", marginTop: "30px" }}>
          <PanelButtons items={items} isLink={false} page={page} />
        </div>
        <div>
          {page === "info" && (
            <ShiftDetailsInfoTab
              loadingShift={loadingShift}
              shift={getShiftResult}
              pageMode={pageMode}
              employees={employees}
              setEmployees={setEmployees}
              form={formData}
            />
          )}
          {page === "wet-stock-inventory" && (
            <WetStockTab
              isShiftEndedCompletely={isShiftEndedCompletely}
              shift={{
                ...getShiftResult,
                // recentShiftDetailed: getRecentShiftResult,
              }}
              progress={progress}
              pageMode={pageMode}
              form={formData}
              beginDidNotPerformDipStick={beginDidNotPerformDipStick}
              setBeginDidNotPerformDipStick={setBeginDidNotPerformDipStick}
              endDidNotPerformDipStick={endDidNotPerformDipStick}
              setEndDidNotPerformDipStick={setEndDidNotPerformDipStick}
              remarksUgt={remarksUgt}
              setRemarksUgt={setRemarksUgt}
            />
          )}
          {page === "dry-stock-inventory" && (
            <DryStockTab
              isShiftEndedCompletely={isShiftEndedCompletely}
              shift={getShiftResult}
              pageMode={pageMode}
              form={formData}
              inventory={inventory}
              setInventory={setInventory}
            />
          )}
          {page === "cash-noncash" && (
            <CashNonCashTab
              shift={getShiftResult}
              pageMode={pageMode}
              setSafeDrop={setSafeDrop}
              safeDrop={safeDrop}
              employees={employees}
              setEmployees={setEmployees}
              employeesToPay={employeesToPay}
              setEmployeesToPay={setEmployeesToPay}
              variance={variance}
              setVariance={setVariance}
              refetchShift={refetchShift}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ShiftRecordDetailsModule;
